import { Presenter } from '../../presenters/presenter';
import type { BookingType } from './booking-type';

export class BookingTypePresenter extends Presenter<BookingType> {
    get description(): string {
        return this.data.description;
    }

    get name(): string {
        return this.data.description;
    }
}
